<template>
    <div class="my_monitor_box" style="position:relative;height: 100%; min-height: 726px;background: #fff;">
        <Row class="table-style-size">
            <i-col span="6">订单号</i-col>
            <i-col span="6">监测描述</i-col>
            <i-col span="6">提交时间</i-col>
        </Row>

        <div v-if="JSON.stringify(data) != '{}' && data.records.length!=0">
            <Row class="table-style-size table-style-body" style="height:90px" v-for="(item,index) in data.records" :key="index">
                <i-col span="6">{{ item.id }}</i-col>
                <i-col span="6" class="evdience-table">
                    <Tooltip style="max-width: 100%;" max-width="200" :content="item.monitorDesc"><p style="width:184px"   class="partial_result_url">{{ item.monitorDesc }}</p></Tooltip>
                </i-col>
                <i-col span="6">{{ item.createDate }}</i-col>

            </Row>
            <div style="height:80px"></div>
   
            <div class="commont-page" style="position: absolute;width: 100%;bottom: 0;height:80px;padding:0;">
                <Page :page-size="pageSize" :current="data.current-0" @on-change="changepage" :total="total" size="small" show-total show-elevator class="page-size-style"></Page>
                <span class="page-total-span">/&nbsp;{{pages}}页</span>
            </div>
        </div>

        <errorTips v-else></errorTips>
    </div>

</template>

<script>
    import errorTips from '@/views/main-components/error-tips';

    export default {
        name: 'myMonitorComponents',
        components:{
            errorTips
        },
        props:{
            tabType: {
                type: String,
                default: ""
            },
            data: {
                type: Object,
                default: {}
            },
            total: {
                type: Number,
                default: 0
            },
            pages: {
                type: Number,
                default: 0
            },
            pageSize: {
                type: Number,
                default: 8
            },
        },
        data() {
            return {
            }
        },

        methods:{
            changepage(value){
                this.$emit("fatherReceivePage",value);
            }
        }
    }
</script>
<style>
    .my_monitor_box{

        position: relative;
    }
    .text_ellipsis{
        overflow: hidden;
        text-overflow: ellipsis;
        width: 100%;
        white-space: nowrap;
        padding: 0 10px;
    }
    .workImage{
        object-fit: cover;
    }

    .partial_result_url {
        display: block;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

 
</style>